// extracted by mini-css-extract-plugin
export var productImage = "_rv-1";
export var viewLink = "_rv-2";
export var wishlistItem = "_rv-0";